export const getSellThruValue = (hpSob: number, hpSellThru: number, sob: number) => {
  if (!hpSellThru || !hpSob) {
    return null
  }
  return (sob * hpSellThru) / hpSob
}
